import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";

const BASE_URL = "https://olyinvestment.com";

export default function SEOHead() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const isAr = currentLang === "ar";

  return (
    <Helmet>
      <html lang={currentLang} dir={isAr ? "rtl" : "ltr"} />
      <title>{t("seo.title")}</title>
      <meta name="description" content={t("seo.description")} />
      <meta property="og:title" content={t("seo.title")} />
      <meta property="og:description" content={t("seo.description")} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={currentLang === "tr" ? "tr_TR" : currentLang === "en" ? "en_GB" : currentLang === "ar" ? "ar_SA" : "ru_RU"} />
      {LANGUAGES.map((lang) => (
        <link key={lang.code} rel="alternate" hrefLang={lang.code} href={`${BASE_URL}/${lang.code}/`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}/tr/`} />
      <link rel="canonical" href={`${BASE_URL}/${currentLang}/`} />
    </Helmet>
  );
}
